import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FaCircle } from "react-icons/fa";
// import { MdDownload } from "react-icons/md";
// import { FaCheckCircle } from "react-icons/fa";
import PropTypes from "prop-types";
import config from "../../../../config";
import { AuthContext } from "../../../../context/AuthContext";
import { useSession } from "../../../../context/SessionTracker";
import SelectSticker from "./SelectSticker";
import SelectLink from "./SelectLink";
import PasteLink from "./PasteLink";

const ShareToInstagram = ({
  setGenerateLinkNow,
  generatedLink,
  generatedElements,
  isLoadingImage,
  selectedImageIndex,
  setSelectedImageIndex,
  linkOrWishlist,
  setShowDownloadBtn,
  // setIsLastStep,
  //setDownloadFunction,
  details
}) => {
  const [showInstaSteps, setShowInstaSteps] = useState(true);
  const [currentStep, setCurrentStep] = useState(0);
  const [isLinkGenerated, setIsLinkGenerated] = useState(false);
  const [caution, setCaution] = useState(null);
  const { user } = useContext(AuthContext);
  const { trackEvent } = useSession();
  const navigate = useNavigate();

  useEffect(() =>{
    if(generatedLink){
      setIsLinkGenerated(true);
    }
  }, [generatedLink])

  // copy to clipboard must not be in a useEffect hook for mobile devices
  const handleCopyToClipboard = () => {
    if(isLinkGenerated){
      const link = `${config.publicUrl}/${linkOrWishlist}/${user.username}`;
    
      navigator.clipboard
        .writeText(link)
        .then(() => {
          setCaution("Link copied to clipboard!");
          // Clear alert after 3 seconds
          setTimeout(() => setCaution(null), 3000);
        })
        .catch((error) => {
          console.error("Could not copy link to clipboard:", error);
          setCaution("Could not copy link. Please try again later.");
          setTimeout(() => setCaution(null), 3000);
        });
    }
  };


  // Handle sharing to Instagram Story
  const nextStep = async () => {
    setShowInstaSteps(true);
    
    // increment step counter
    setCurrentStep((prev) => {
      const nextStep = prev + 1;
      if(nextStep === 3){
        handleCopyToClipboard();
      }

      if(nextStep === 4){
        try {
          // Detect if the user is on a mobile device
          const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
          
          if(!isMobile){
            setCaution("Cannot share stories on desktop, please continue on your phone.");
            setTimeout(() => {}, 3000);
            // navigate back to the home page
            navigate("/");
          } else {
            try {
              const instaUrl = "instagram://story-camera" ;
              console.log("share link details: ", details);
              trackEvent("linkShare", details, {
                destination: "instagram",
                user_agent: window.navigator.userAgent,
              });
              navigate("/");
              window.open(instaUrl, "_blank");
            } catch {
                const fullInstaUrl = "https://www.instagram.com";
                navigate("/");
                window.open(fullInstaUrl, "_blank");
            }
          }

        } catch (error) {
          console.error("could not open window to instagram", error);
          // TODO: Provide feedback to the user about the failure
        }
      }
      // prevent incrementing beyond the array length  
      return nextStep < stepImages.length ? nextStep : prev;
    });
    // handle specific step situations here
    if(currentStep === 1 && generatedElements){
      setGenerateLinkNow(true);
    }
  };

  const stepImages = [
    null,
    <SelectSticker key="step-2" details={details} index={selectedImageIndex} />,
    <SelectLink key="step-3"/>,
    <PasteLink key="step-4"/>,
  ];
  

  const stepInstructions = [
    "Optional: download image",
    "Create a story, then click the sticker button",
    "Add a link sticker",
    "Paste your link and post",
  ];

  useEffect(() => {
    if(currentStep != 0){
      setShowDownloadBtn(false);
    } else {
      setShowDownloadBtn(true);
    }
  }, [currentStep])

  useEffect(() => {
    const container = document.querySelector(".image-selection-container");
    if (!container) return;
    let frameId = null; // To hold the requestAnimationFrame ID

    // Define the scroll event listener function
    const onScroll = () => {
      if (frameId !== null) {
        cancelAnimationFrame(frameId);
      }

      frameId = requestAnimationFrame(() => {
        let closestIndex = 0;
        let closestDistance = Infinity;
        const thumbnails = document.querySelectorAll(".thumbnail"); // Move inside the event listener if thumbnails might change

        thumbnails.forEach((thumbnail, index) => {
          const scrollPosition =
            container.scrollLeft + container.offsetWidth / 2;
          const thumbnailCenter =
            thumbnail.offsetLeft + thumbnail.offsetWidth / 2;
          const distance = Math.abs(scrollPosition - thumbnailCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        thumbnails.forEach((thumbnail, index) => {
          if (index === closestIndex) {
            thumbnail.classList.add("active");
            setSelectedImageIndex(index);
          } else {
            thumbnail.classList.remove("active");
          }
        });
      });
    };

    // Add the event listener
    container.addEventListener("scroll", onScroll);

    return () => {
      container.removeEventListener("scroll", onScroll);
      if (frameId !== null) {
        cancelAnimationFrame(frameId);
      }
    };
  }, [generatedElements]);

  return (
    <>
      {/* Instagram steps */}
      {showInstaSteps && !isLoadingImage && generatedElements && (
        <div className="insta-steps-container">
          <div className="progress-circles-container">
            {stepImages.map((_, index) => (
              <FaCircle
                key={index}
                className={`circle-icon ${
                  index <= currentStep ? "active" : ""
                }`}
                onClick={() => setCurrentStep(index)}
              />
            ))}
          </div>
          <div className="step-descriptions-container">
            <p>{stepInstructions[currentStep]}</p>
          </div>

          <div className="steps-and-images-container">
            <div className="image-row-container">
              {/* Selected Image */}
              {currentStep > 0 && (
                <div className="selected-image-container">
                  {stepImages[currentStep]}
                </div>
              )}
              {/* Thumbnails */}
              {details.type == "wishlist" &&
                <div
                  className={`image-selection-container ${
                    currentStep === 0 ? "with-padding" : ""
                  }`}
                  >
                  {currentStep === 0 &&
                    generatedElements.length > 0 &&
                    generatedElements.map((element, index) => (
                      <div
                        key={index}
                        id={`thumbnail-container-${index}`}
                          className={`thumbnail ${
                            selectedImageIndex === index ? "active" : ""
                          }`}
                          onClick={() => {
                            setSelectedImageIndex(index);
                            // scrollToThumbnail(index)
                        }}
                      >
                        {element}
                      </div>
                    ))}
                </div>
              }

              {details.type != "wishlist" &&
                <div
                  className={`image-selection-container ${
                    currentStep === 0 ? "with-padding" : ""
                  }`}
                  >
                  {currentStep === 0 &&
                    generatedElements.length > 0 &&
                    generatedElements.map((element, index) => (
                      <div
                      key={index}
                      id={`thumbnail-container-${index}`}
                        className={`thumbnail ${
                          selectedImageIndex === index ? "active" : ""
                        }`}
                        onClick={() => {
                          setSelectedImageIndex(index);
                          // scrollToThumbnail(index)
                        }}
                      >
                        {element}
                      </div>
                    ))}
                </div>
              }
            </div>
          </div>
          {/* Alert and button container */}
          <div className="alert-and-button">
            <button
              className="share-button"
              type="button"
              onClick={nextStep}
            >
              {currentStep === 3 ? "Share!" : "Next Step"}
            </button>
            {caution && 
              <div className="alert">
                  <div className="caution">
                    {caution}
                  </div>
              </div>
            }
          </div>
        </div>
      )}
    </>
  );
};

export default ShareToInstagram;

ShareToInstagram.propTypes = {
  setGenerateLinkNow: PropTypes.func,
  generatedLink: PropTypes.object,
  generatedElements: PropTypes.array,
  isLoadingImage: PropTypes.bool,
  downloadImage: PropTypes.func,
  selectedImageIndex: PropTypes.number,
  setSelectedImageIndex: PropTypes.func,
  // setDownloadFunction: PropTypes.func,
  details: PropTypes.object,
  linkOrWishlist: PropTypes.string,
  setShowDownloadBtn: PropTypes.func,
  setIsLastStep: PropTypes.func
};
